class WebSocketService {
  constructor(url) {
    this.url = url
    this.ws = null
    this.reconnectAttempts = 0
    this.reconnectMaxAttempts = 5
    this.reconnectInterval = 3000
    this.heartbeatTimer = null
    this.heartbeatInterval = 30000
    this.messageCallbacks = []
    this.openCallbacks = []
    this.closeCallbacks = []
    this.errorCallbacks = []
  }

  // 初始化连接
  connect() {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) return

    try {
      this.ws = new WebSocket(this.url)
      this.initEventHandlers()
    } catch (error) {
      this.triggerErrorCallbacks(error)
      this.reconnect()
    }
  }

  // 初始化WebSocket事件处理
  initEventHandlers() {
    this.ws.onopen = () => {
      console.log('WebSocket连接已建立')
      this.reconnectAttempts = 0
      this.startHeartbeat()
      this.triggerOpenCallbacks()
    }

    this.ws.onmessage = event => {
      try {
        const data = JSON.parse(event.data)
        this.triggerMessageCallbacks(data)
      } catch (error) {
        console.error('WebSocket消息解析错误:', error)
        this.triggerMessageCallbacks(event.data)
      }
    }

    this.ws.onclose = event => {
      console.log('WebSocket连接已关闭', event)
      this.stopHeartbeat()
      this.triggerCloseCallbacks(event)
      if (!event.wasClean) {
        this.reconnect()
      }
    }

    this.ws.onerror = error => {
      console.error('WebSocket连接错误:', error)
      this.triggerErrorCallbacks(error)
    }
  }

  // 发送消息
  send(data) {
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
      console.error('WebSocket未连接，无法发送消息')
      return false
    }

    try {
      const message = typeof data === 'object' ? JSON.stringify(data) : data
      this.ws.send(message)
      return true
    } catch (error) {
      console.error('WebSocket发送消息错误:', error)
      return false
    }
  }

  // 断开连接
  disconnect() {
    if (this.ws) {
      this.stopHeartbeat()
      this.ws.close()
    }
  }

  // 重新连接
  reconnect() {
    if (this.reconnectAttempts >= this.reconnectMaxAttempts) {
      console.log('WebSocket重连次数已达上限，不再尝试重连')
      return
    }

    this.reconnectAttempts++
    console.log(`WebSocket尝试重连 (${this.reconnectAttempts}/${this.reconnectMaxAttempts})...`)

    setTimeout(() => {
      this.connect()
    }, this.reconnectInterval)
  }

  // 开始心跳检测
  startHeartbeat() {
    this.stopHeartbeat()
    this.heartbeatTimer = setInterval(() => {
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        this.send({ type: 'heartbeat', timestamp: Date.now() })
      }
    }, this.heartbeatInterval)
  }

  // 停止心跳检测
  stopHeartbeat() {
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer)
      this.heartbeatTimer = null
    }
  }

  // 添加消息监听
  onMessage(callback) {
    if (typeof callback === 'function') {
      this.messageCallbacks.push(callback)
    }
  }

  // 添加连接成功监听
  onOpen(callback) {
    if (typeof callback === 'function') {
      this.openCallbacks.push(callback)
    }
  }

  // 添加连接关闭监听
  onClose(callback) {
    if (typeof callback === 'function') {
      this.closeCallbacks.push(callback)
    }
  }

  // 添加错误监听
  onError(callback) {
    if (typeof callback === 'function') {
      this.errorCallbacks.push(callback)
    }
  }
  // 移除监听
  removeListener(callback) {
    this.messageCallbacks = this.messageCallbacks.filter(cb => cb !== callback)
    this.openCallbacks = this.openCallbacks.filter(cb => cb !== callback)
    this.closeCallbacks = this.closeCallbacks.filter(cb => cb !== callback)
    this.errorCallbacks = this.errorCallbacks.filter(cb => cb !== callback)
  }

  // 触发消息回调
  triggerMessageCallbacks(data) {
    this.messageCallbacks.forEach(callback => {
      try {
        callback(data)
      } catch (error) {
        console.error('WebSocket消息回调执行错误:', error)
      }
    })
  }

  // 触发连接成功回调
  triggerOpenCallbacks() {
    this.openCallbacks.forEach(callback => {
      try {
        callback()
      } catch (error) {
        console.error('WebSocket打开回调执行错误:', error)
      }
    })
  }

  // 触发连接关闭回调
  triggerCloseCallbacks(event) {
    this.closeCallbacks.forEach(callback => {
      try {
        callback(event)
      } catch (error) {
        console.error('WebSocket关闭回调执行错误:', error)
      }
    })
  }

  // 触发错误回调
  triggerErrorCallbacks(error) {
    this.errorCallbacks.forEach(callback => {
      try {
        callback(error)
      } catch (err) {
        console.error('WebSocket错误回调执行错误:', err)
      }
    })
  }
}

export default WebSocketService



// WEBPACK FOOTER //
// ./src/components/fireStation/socket.js